<div class="action-bar">
  <keyboard-shortcuts-interceptor *ngIf="shouldShowSave || shouldShowDuplicate" (onSave)="shouldShowSave && onSave.emit()" (onDuplicate)="shouldShowDuplicate && onDuplicate.emit()"></keyboard-shortcuts-interceptor>

  <button *ngIf="shouldShowSave" mat-mini-fab class="action-button" type="submit" (click)="onSave.emit()" [matTooltip]="'action_bar_save' | translate">
    <mat-icon>save</mat-icon>
  </button>

  <button *ngIf="shouldShowResetPassword" type="button" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_reset_password' | translate" (click)="onResetPassword.emit()">
    <mat-icon>lock_open</mat-icon>
  </button>

  <button *ngIf="shouldShowAddToFavorites" type="button" mat-mini-fab class="action-button grey-button-color fav-add" [matTooltip]="'action_bar_add_to_favorites' | translate" (click)="onAddToFavorites.emit()">
    <mat-icon>star_border</mat-icon>
  </button>

  <button *ngIf="shouldShowRemoveFromFavorites" type="button" mat-mini-fab class="action-button yellow-button-color" [matTooltip]="'action_bar_remove_from_favorites' | translate" (click)="onRemoveFromFavorites.emit()">
    <mat-icon>star</mat-icon>
  </button>

  <button *ngIf="shouldShowCalculCEU" type="button" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_calculate_ceu' | translate" (click)="onCalculCEU.emit()">
    <mat-icon svgIcon="sigma" class="sigma"></mat-icon>
  </button>

  <button *ngIf="shouldShowSwitch" type="button" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_change_agency' | translate" (click)="onSwitch.emit()">
    <mat-icon>sync_alt</mat-icon>
  </button>

  <button *ngIf="shouldShowShare" type="button" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_share' | translate" (click)="onShare.emit()">
    <mat-icon>share</mat-icon>
  </button>

  <button *ngIf="shouldShowDownload" type="button" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_export_excel' | translate" (click)="onDownload.emit()">
    <mat-icon>download</mat-icon>
  </button>

  <button *ngIf="shouldShowExport" type="button" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_export' | translate" (click)="onExport.emit()">
    <mat-icon>file_download</mat-icon>
  </button>

  <button *ngIf="shouldShowSleep" type="button" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_sleep' | translate" (click)="onSleep.emit()">
    <mat-icon>{{ isSleepingMode ? 'notifications_active' : 'notifications_off' }}</mat-icon>
  </button>

  <button *ngIf="shouldShowDuplicate" mat-mini-fab class="action-button grey-button-color" [matTooltip]="'action_bar_duplicate' | translate" (click)="onDuplicate.emit()">
    <mat-icon>content_copy</mat-icon>
  </button>

  <button *ngIf="shouldShowDelete" mat-mini-fab class="action-button" color="warn" [matTooltip]="'action_bar_delete' | translate" (click)="onDelete.emit()">
    <mat-icon>delete_outline</mat-icon>
  </button>
</div>
